export interface LicenseDetails {
  number: string;
  type: string;
  nameOnLicense: string;
  status: string;
  issueDate: Date | string;
  expirationDate: Date | string;
  application_id?: string;
  id?: string;
  licenseFee?: number;
  extendable?: boolean;
  extensionDuration?: string;
  applicationNumber?: number;
   endorsements?: string | string[];
  provisions?: string | any[];
  strLicenseKind?: string;
  strEndorsement?: string;
  cd_endo_status?: string;
    strEndoStatus?: string;

}

// API Response Interfaces
export interface DashboardApiResponse {
  status: 'success' | 'error';
  data: {
    success: boolean;
    data: DashboardData[];
  };
  message?: string;
  errorCode?: string;
}

export interface DashboardData {
  Obj_Profile: ProfileData;
  li_Application: ApplicationData[];
  li_Documents: DocumentData[];
  Obj_License: LicenseData;
  li_Transaction:TransactionData[];
  Obj_LicenseKind:LicenseKindData;
  li_payment_breakdown:PaymentBreakdownData[];
}

export interface ProfileData {
  strPersonName: string;
  strEmail: string;
  dtDateCreated: string | null;
  dtPreviousLogin: string | null;
  strBannerHeaderName: string;
}

export interface ApplicationData {
  strAppId: string;
  strAppType: string;
  dtDateCreated: string;
  dtDateSubmitted: string;
  strAppStatus: string;
}

export interface DocumentData {
  strAppId: string;
  strDocumentId: number;
  strCategory: string;
  strType: string;
  strFileName: string;
  strStatus: string;
  strUploadedBy: string;
  dtUploadedDate: string;
  strApplicationStatus:string;
  strApplicationType:string;
}

export interface LicenseData {
  strLicenseNumber: string;
  boolIsActive: boolean;
  strNameOnLicense: string | null;
  dtIssueDate: string | null;
  dtExpiryDate: string | null;
  strLicenseExpirationFee?: string | null;
    strEndoStatus?: string;
  dtEndIssueDate?:string;
  strEndorsementPathway?: string;

}

export interface LicenseKindData {
  boolIsActive: boolean;
  strLicenseType: string;
  strLicenseKind: string;
  strEndorsement:string;
  strEndorsmentGrade: string;
  dtOriginalEffectiveDate: string;
  dtEffectiveDate: string;
  dtExpiryDate: string;
  strLicenseKindStatus: string;
}

export interface TransactionData {
  strPersonId: number,
  strTransactionType: string;
  strTransactionStatus: string,
  strPaymentTransactionId: number,
  strAmount: number,
  dtTransactionDate: string,
  strApplicantName: string,
  dtReceiptTransactionDate:string
}

export interface PaymentBreakdownData {
  strpaymentHistoryId: number;
  strapplicationNumber: string;
  strInvoiceNumber: string;
  cd_revenue_code: string | null;
  is_discount: boolean;
  is_refund: boolean;
  revenue_code: string;
  revenue_code_desc: string | null;
  strPaymentAmount: string;
  strPrice: string;
  strQuantity: number;
  strPaymentMethod: string;
  strPaymentComment: string;
  strTransactionDate: string;
  strReceiptNumber: string | null;
}

// Component Use Interfaces
export interface Profile {
  name: string;
  email: string;
  registered: Date | string;
  lastLogin: Date | string;
  bannerHeaderName: string;
}

export interface Application {
  id: string;
  type: string;
  dateCreated: Date;
  dateSubmitted: Date;
  status: string;
}

export interface Document {
  id?: string;
  application_id?: string;
  applicationId: string;
  document_id?: number;
  documentId: number;
  category: string;
  type: string;
  document_type?: string;
  file_name?: string;
  fileName: string;
  document_status?: string;
  status: string;
  uploaded_by?: string;
  uploadedBy: string;
  due_date?: string;
  uploadDate: Date;
  // Optional: date the related application was submitted (formatted string MM/DD/YYYY)
  submission_date?: string | null;
  // Optional created date if present on document rows
  created_date?: string | null;
  application_type?: string;
  application_status?: string;
}

export interface Transaction {
 id?: string;
 personId?: number;
 transactionType?: string;
 transactionStatus?: string;
 paymentTransactionId?: number | string;
 amount?: number | string;
 transactionDate?: string;
 transaction_Date: Date;
 application_id?: string;
 application_type?: string;
 applicantName?: string;
 receiptDate?: string;
 invoiceNumber?: string;
 receiptTransactionDate?:string;
}

export interface PaymentBreakdown {
  id?: string;
 application_id?: string;
 invoiceNumber?: string;
 revenueCode?: string;
 revenueCodeDesc?: string;
 /** Lookup 417 key used for fee display order */
 feeCategoryKey?: string;
 paymentHistoryId?: number | string;
 /** Raw timestamptz for sorting (before display format) */
 rawTransactionDate?: string | Date;
 transactionDateTime?: string;
 receiptNumber?: string;
 quantity?: number | string;
 price?: string;
 paymentAmount?: string;
 paymentMethod?: string;
 comments?: string;
}
